import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useAnalytics } from "@/contexts/AnalyticsContext";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Reports a view whenever the router lands on a new path.
 *
 * The URL is left to the SDK: the send hook strips query strings and fragments
 * from every URL already, so naming one here would be a second definition of
 * what is safe to send. Nothing is reported until the session is restored, or
 * the opening view lands on whoever used this browser last.
 */
export function useAnalyticsPageview() {
  const analytics = useAnalytics();
  const { isLoading } = useAuth();
  const { pathname } = useLocation();
  const reportedRef = useRef<string | null>(null);

  useEffect(() => {
    if (isLoading) return;
    if (reportedRef.current === pathname) return;
    reportedRef.current = pathname;
    analytics.capture("$pageview");
  }, [analytics, isLoading, pathname]);
}
